import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CompanyTrainingService } from '../services/companytraining.service';
import { SystemCodeService } from '../services/system-code.service';
import { SystemCode } from '../models/system-codes.model';
import { CompanyTraining } from '../models/companytraining.model';
import { AngularCsv } from 'angular7-csv';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { GlobalConstants } from '../common/global-constants';
import { MemberTrainingHoursModel } from '../models/membertraininghours.model';
import { RolePermissionCheck } from '../models/role-permission-check.model';
import { ActivatedRoute } from '@angular/router';
import { NgModel } from '@angular/forms';



@Component({
    selector: 'training-report',
    templateUrl: './training-location-report.component.html',
    styleUrls: ['./training-location-report.component.css']
})

export class TrainingLocationReportComponent implements OnInit {

    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    resultsLength: number = 0;
    locations: SystemCode[] = [];
    startMaxDate: Date;
  endMinDate: Date;
  @ViewChild('startDateControl', { static: false }) startDateControl!: NgModel;
  @ViewChild('endDateControl', { static: false }) endDateControl!: NgModel;
    @BlockUI() blockUI: NgBlockUI;
    endDateDisable: boolean = false;
    fontName: string = GlobalConstants.fontName;
    fontSize: number = GlobalConstants.fontSize;
    headSize: number = GlobalConstants.headingSize;
    footerFontSize: number = GlobalConstants.footerFontSize;
    rolePermissionCheckModel: RolePermissionCheck;
    dateRangeInvalid: boolean = false;
    searchModel = {
        location: 0,
        startDate: null,
        endDate: null
    };

    companyTrainings: CompanyTraining[] = [];

    memberTrainingHoursList: MemberTrainingHoursModel[] = [];

    dataSource = new MatTableDataSource<MemberTrainingHoursModel>();

    displayedColumns: string[] = [
        'memberName',
        'location',
        'totalHours'
    ];

    constructor(
        private companyTrainingService: CompanyTrainingService,
        private systemCodeService: SystemCodeService,
        private route: ActivatedRoute
    ) {
      this.rolePermissionCheckModel = this.route.snapshot.data['rolePermissions'];
    }

  ngOnInit(): void {
    if (this.rolePermissionCheckModel && this.rolePermissionCheckModel.isRead) {
      this.loadLocations();
      this.dataSource = new MatTableDataSource([]);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.startMaxDate = new Date("12/30/2100");
      this.endMinDate = new Date("12/30/1900");
     }
    }

    loadLocations() {

        this.systemCodeService
            .getSystemCodesForCompanyTrainingLocations()
          .subscribe(res => {
              this.locations = res || [];
            const defaultLocation = this.locations.find(x => x.systemCodeId === 2086);

            if (defaultLocation) {
              this.searchModel.location = defaultLocation.systemCodeId;
            }
            this.getTrainingHoursByMemberLocation();
          });

    }

    searchReport() {

      this.getTrainingHoursByMemberLocation();
    }
  getTrainingHoursByMemberLocation(): void {

    this.blockUI.start();
    var loc = (this.searchModel.location == null || this.searchModel.location == undefined || this.searchModel.location == 0) ? "0" : this.searchModel.location.toString();
    const startDate = this.searchModel.startDate
      ? this.formatDate(this.searchModel.startDate)
      : null;

    const endDate = this.searchModel.endDate
      ? this.formatDate(this.searchModel.endDate)
      : null;
    this.companyTrainingService.getTrainingHoursByMemberLocation(
      loc,
      startDate,
      endDate
    ).subscribe(res => {

      this.memberTrainingHoursList = res || [];
      this.resultsLength = this.memberTrainingHoursList.length;

      if (!this.dataSource) {
        this.dataSource = new MatTableDataSource(this.memberTrainingHoursList);
      } else {
        this.dataSource.data = this.memberTrainingHoursList;
      }

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.blockUI.stop();

    }, err => {
      this.blockUI.stop();
    });
  }
    exportCSV() {

        let data = [];

        data.push({
            memberName: 'Member Name',
            location: 'Location',
            totalHours: 'Total Hours'
        });

        this.memberTrainingHoursList.forEach(x => {

            data.push({
                memberName: x.memberName,
                location: x.location,
                totalHours: this.formatHours(x.totalHours)
            });

        });

        new AngularCsv(data, 'Training Report');

    }
  resetReport() {
    this.searchModel = {
      location: 2086,
      startDate: null,
      endDate: null
    };
    if (this.startDateControl) {
      this.startDateControl.reset();
    }

    if (this.endDateControl) {
      this.endDateControl.reset();
    }
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 15;
    this.startMaxDate = null;
    this.endMinDate = null;
    this.endDateDisable = false; 
    this.companyTrainings = [];
    this.memberTrainingHoursList = [];
    this.dataSource = new MatTableDataSource([]);
    this.getTrainingHoursByMemberLocation(); 

  }
  startDateChange(dt: Date) {
    this.endMinDate = new Date(dt);
    this.endDateDisable = true;
    if (dt == null) {
      this.searchModel.endDate = null;
      this.endDateDisable = false;
    }
  }
  printReport():void {
    let yAxis: number = 30;

    const doc = new jsPDF('l', 'mm', 'letter');

    doc.setFont(this.fontName);
    const pdfTitle = 'Training Report';
    const footerSize = this.footerFontSize;
    let grandTotal = this.getGrandTotal();
    doc.setProperties({
      title: pdfTitle
    });

    let totalPagesExp = '{total_pages_count_string}';

    doc.setTextColor(40);
    doc.setFontSize(this.headSize);

    let textWidth =
      doc.getStringUnitWidth(pdfTitle) *
      doc.getFontSize() /
      doc.internal.scaleFactor;

    let textOffset =
      (doc.internal.pageSize.width - textWidth) / 2;

    doc.text(pdfTitle, textOffset, 20);

    doc.setFontSize(this.fontSize);

    let pageSize = doc.internal.pageSize;
    let pageWidth = pageSize.width
      ? pageSize.width
      : pageSize.getWidth();

    let startDate = 'Start Date: ';

    if (this.searchModel.startDate) {

      let startDateString = new Date(this.searchModel.startDate);

      startDate += this.getDateAsString(startDateString);

    }

    let endDate = 'End Date: ';

    if (this.searchModel.endDate) {

      let endDateString = new Date(this.searchModel.endDate);

      endDate += this.getDateAsString(endDateString);

    }

    let text = doc.splitTextToSize(startDate + ' - ' + endDate, pageWidth - 35);

    doc.text(text, pageWidth / 2, yAxis, { align: 'center' });

    yAxis += 5;

    let location = 'Location: ';

    let loc =
      this.searchModel.location != null
        ? parseInt(this.searchModel.location.toString())
        : 0;

    let locationEntity =
      this.locations.find(x => x.systemCodeId == loc);

    if (locationEntity) {

      location += locationEntity.type;

    }

    text = doc.splitTextToSize(location, pageWidth - 35);

    doc.text(text, pageWidth / 2, yAxis, { align: 'center' });

    yAxis += 5;

    autoTable(doc, {

      startY: yAxis,

      head: [
        [
          'Member Name',
          'Location',
          'Total Hours'
        ]
      ],

      body: this.memberTrainingHoursList.map(x => [
        x.memberName,
        x.location,
        this.formatHours(x.totalHours)
      ]),

      headStyles: {
        minCellHeight: 8,
        fillColor: '#ff4242',
        font: this.fontName,
        fontStyle: 'bold',
        fontSize: this.fontSize
      },

      bodyStyles: {
        minCellHeight: 8,
        fillColor: null,
        font: this.fontName,
        fontSize: this.fontSize
      },

      didDrawPage: function () {

        let str = 'Page ' + doc.getNumberOfPages();

        if (typeof doc.putTotalPages === 'function') {

          str = str + ' of ' + totalPagesExp;

        }

        doc.setFontSize(footerSize);

        let pageSize = doc.internal.pageSize;

        let pageHeight =
          pageSize.height
            ? pageSize.height
            : pageSize.getHeight();

        doc.text(str, 130, pageHeight - 10);

        let totalVal = grandTotal.toString();
        let arr = totalVal.split(".");

        if (arr.length === 1 || arr[1].length < 2) {
          totalVal = grandTotal.toFixed(2);
        }

        doc.text('Total - ' + totalVal, 235, pageHeight - 10);

        let currentDate = new Date();

        let dd =
          (currentDate.getDate() < 10 ? '0' : '') +
          currentDate.getDate();

        let mm =
          ((currentDate.getMonth() + 1) < 10 ? '0' : '') +
          (currentDate.getMonth() + 1);

        let currentDateString =
          mm + '/' + dd + '/' + currentDate.getFullYear();

        doc.text(currentDateString, 15, pageHeight - 10);

      }

    });


    if (typeof doc.putTotalPages === 'function') {

      doc.putTotalPages(totalPagesExp);

    }
    window.open(URL.createObjectURL(doc.output("blob")));


  }
  getDateAsString(dt: Date): string {
    let dd = (dt.getDate() < 10 ? '0' : '') + dt.getDate();
    let MM = ((dt.getMonth() + 1) < 10 ? '0' : '') + (dt.getMonth() + 1);
    return MM + "/" + dd + "/" + dt.getFullYear();
  }
  formatHours(value: number): string {

    if (value === null || value === undefined) {
      return '';
    }

    return value % 1 === 0
      ? value.toFixed(1)
      : value.toString();

  }
  getGrandTotal(): number {
    let total = 0;

    this.memberTrainingHoursList.forEach(x => {
      if (x.totalHours) {
        total += Number(x.totalHours);
      }
    });

    return total;
  }
  formatDate(date: Date): string {
    const d = new Date(date);
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const dd = ('0' + d.getDate()).slice(-2);
    return `${mm}/${dd}/${d.getFullYear()}`;
  }
}//Training Report Added By SureshKumar S - Bug Id 8325

